import request from '@/utils/request'
import qs from 'qs'
// 更新子账户手机号
export function updatePhone(data) {
  return request({
    url: '/api/childuser/updatePhone',
    method: 'put',
    data
  })
}
export function getPhone(data) {
  return request({
    url: '/api/childuser/getPhone',
    method: 'get',
    params:data
  })
}


export function login(data) {
  data = qs.stringify(data)
  return request({
    url: '/api/login/userLogin',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data
  })
}
export function loginChild(data) {
  data = qs.stringify(data)
  return request({
    url: '/api/login/ChildUserLogin?' + data,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function getInfo(token) {
  return request({
    url: '/api/login/test',
    method: 'get',
    params: {
      token
    }
  })
}

export function logout() {
  return request({
    url: '/vue-element-admin/user/logout',
    method: 'post'
  })
}

export function userInfo(token) {
  return request({
    url: '/api/user/info',
    method: 'get',
    headers: {
      Authorization: token
    }
  })
}

// export function loginChild(token) {

//   return request({
//     url: '/api/login/ChildUserLogin',
//     method: 'get',
//     headers: { Authorization: token }
//   })
// }

export function userImage(token) {
  return request({
    url: '/api/user/url',
    method: 'get'
    // headers: {
    //   Authorization: token
    // }
  })
}

export function findRouteMapping() {
  return request({
    url: '/api/menu/findRouteMapping',
    method: 'get'
  })
}

export function buildTree({
  arrayList,
  pidStr = 'menuid',
  idStr = 'menuparentid',
  childrenStr = 'children'
}) {
  const listOjb = {} // 用来储存{key: obj}格式的对象
  const treeList = [] // 用来储存最终树形结构数据的数组
  // 将数据变换成{key: obj}格式，方便下面处理数据
  for (let i = 0; i < arrayList.length; i++) {
    listOjb[arrayList[i][idStr]] = arrayList[i]
  }
  // 根据pid来将数据进行格式化
  for (let j = 0; j < arrayList.length; j++) {
    const haveParent = listOjb[arrayList[j][pidStr]]
    if (haveParent) {
      // 如果有没有父级children字段，就创建一个children字段
      !haveParent[childrenStr] && (haveParent[childrenStr] = [])
      // 在父级里插入子项
      haveParent[childrenStr].push(arrayList[j])
    } else {
      treeList.push(arrayList[j])
    }
  }
  return treeList
}

// export function filterAsyncRouter(asyncRouterMap) { // 遍历后台传来的路由字符串，转换为组件对象
//   // let newasyncRouterMap = asyncRouterMap[0]
//   const paths = []
//   const accessedRouters = asyncRouterMap.filter(route => {
//     if (route.path) {
//       paths.push(path)
//     }
//     if (route.children && route.children.length) {
//       route.children = filterAsyncRouter(route.children)
//     }
//     return true
//   })
//   return paths
// }

// 选择用户 角色
// observe/standbylist 获取监管用户的备选单位列表
export function standbylist(token, userId) {
  return request({
    url: '/api/observe/standbylist2',
    method: 'get',
    params: {
      userId
    }
    // headers: {
    //   Authorization: token
    // }
  })
}

// export function observeStandbylist(token, userId) {
//   return request({
//     url: '/api/observe/standbylist',
//     method: 'get',
//     params: {
//       userId
//     },
//     // headers: {
//     //   Authorization: token
//     // }
//   })
// }
// observe/observescope 获取单个监管用户权限列表
export function observescope(token, userId) {
  return request({
    url: '/api/observe/observescope',
    method: 'get',
    params: {
      userId
    }
    // headers: {
    //   Authorization: token
    // }
  })
}
export function postobservescope(token, userId, managerId) {
  return request({
    url: `/api/observe/observescope?managerId=${managerId}&userIds=${userId}`,
    method: 'post',
    headers: {
      Authorization: token
    }
  })
}
